import './App.css';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { LoginCallback, SecureRoute, Security } from '@okta/okta-react';
import { useCallback } from 'react';
import Home from './components/Home';
import Shadow from './components/Shadow';
import { oktaAuth } from './application/common';

const App = () => {
  const restoreOriginalUri = useCallback(async (_oktaAuth: OktaAuth, originalUri: string) => {
    window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
  }, []);

  return (
    <Router>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Switch>
          <Route path="/login/callback" component={LoginCallback} />
          <SecureRoute path="/shadow" exact component={Shadow} />
          <SecureRoute path="/" exact component={Home} />
        </Switch>
      </Security>
    </Router>
  );
};

export default App;
